import { render, staticRenderFns } from "./ActionViewReports.vue?vue&type=template&id=31946413"
import script from "./ActionViewReports.vue?vue&type=script&lang=js"
export * from "./ActionViewReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports